<template>
  <section class="car-auction-section pos-rel oh">
    <BannerLeiloeiro :leiloeiro="getLeiloeiro" :loading="getLeiloeiroLoading" />
    <div class="container mb-5 mt-5" v-if="getLeiloeiro">
      <div>
        <div class="left d-block">
          <h2 class="title mb-3">Leilões</h2>
          <p>Veja todos leilões deste leiloeiro</p>
        </div>
        <div class="filter-buttons d-flex justify-content-center mb-4 mt-4 w-100 flex-wrap">
          <button class="col-sm-11 col-md-5 col-lg-3 m-2 buttons-filter" :class="{ activeButtons: tab === 'aberto' }"
            @click="tab = 'aberto'">
            Abertos
          </button>
          <button class="col-sm-11 col-md-5 col-lg-3 m-2 buttons-filter" :class="{ activeButtons: tab === 'breve' }"
            @click="tab = 'breve'">
            Agendados
          </button>
          <button class="col-sm-11 col-md-5 col-lg-3 m-2 buttons-filter" :class="{ activeButtons: tab === 'fechado' }"
            @click="tab = 'fechado'">
            Encerrados
          </button>
        </div>
      </div>
      <LeiloesPorStatusLeiloeiro v-if="tab === 'aberto'" :key="'aberto'" status="aberto" :slug="slug" />
      <LeiloesPorStatusLeiloeiro v-else-if="tab === 'breve'" :key="'breve'" status="breve" :slug="slug" />
      <LeiloesPorStatusLeiloeiro v-else :key="'fechado'" status="fechado" :slug="slug" />
    </div>
  </section>
</template>

<script>
import BannerLeiloeiro from './components/BannerLeiloeiro.vue';
import LeiloesPorStatusLeiloeiro from './components/LeiloesPorStatusLeiloeiro.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LeiloeiroPerfil',
  components: {
    BannerLeiloeiro,
    LeiloesPorStatusLeiloeiro,
  },
  props: {
    slug: { type: String, required: true },
  },
  data() {
    return {
      tab: 'aberto',
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
    };
  },
  computed: {
    ...mapGetters(['getLeiloeiro', 'getLeiloeiroLoading']),
  },
  methods: {
    ...mapActions(['setLeiloeiroPublico']),
    async carregarPerfil() {
      this.tab = 'aberto';
      await this.setLeiloeiroPublico(this.slug);
      if (!this.getLeiloeiro && !this.getLeiloeiroLoading) {
        this.$router.push({ name: 'error' });
      }
    },
  },
  watch: {
    slug() {
      this.carregarPerfil();
    },
  },
  created() {
    this.carregarPerfil();
  },
};
</script>

<style scoped>
.title {
  color: #171d1c;
}

.buttons-filter {
  border-radius: 13px;
  border: 1px solid #ddd;
  color: v-bind(colorPrimary);
}

.activeButtons {
  background-color: v-bind(colorPrimary);
  color: v-bind(colorConstrast);
}
</style>
